import store from '@/store/index';
import Constant from '@/lib/constant';
import VM from '../main';
import area from '@/pages/shopManagement/area.json';
import AMapJs from 'amap-js';
import { TRACK_ACTIONS, $telescopeEvent } from '../plugins/telescope';
import dayjs from 'dayjs';

const baseRoleKey = Constant.RoleKeyList;

const AMapLoader = new AMapJs.AMapLoader({
  key: process.env.VUE_APP_AMAP_KEY,
  version: '1.4.4',
  security: {
    securityJsCode: process.env.VUE_APP_AMAP_SECRET
  }
});

function parseQuery(qs) {
  qs = qs.replace(/^\?/, '');
  var parts = qs.split(/&/);
  var re = /([^=]+)=(.*)/;
  var query = {};
  for (var i = 0; i < parts.length; i++) {
    var match = re.exec(parts[i]);
    if (match) {
      query[match[1]] = decodeURIComponent(match[2]);
    }
  }
  return query;
}

export const getDevHost = host => {
  if (/\.pre\.|\.qa\.|\d+\.\d+\.|localhost/.test(location.host)) {
    // host = getCookie('devHost');
    host = parseQuery(location.search).zone || getCookie('devHost');
  }
  if (host) {
    return host + '.';
  }
  return '';
};

export const getCookie = name => {
  let cookies = document.cookie.split('; ');
  for (let i in cookies) {
    let arr = cookies[i].split('=');
    if (name === arr[0]) return unescape(arr[1]);
  }
  return null;
};
export const getApigw = () => {
  const host = location.host;
  if (/\.qa\.|\d+\.\d+\.|localhost/.test(host)) {
    return `${location.protocol}//apigw.qa.91jkys.com/`;
  } else if (/\.pre\./.test(host)) {
    return `${location.protocol}//apigw.pre.91jkys.com/`;
  } else {
    return `https://apigw-volc.91jkys.com/`;
  }
};
export const getStatic = () => {
  const host = location.host;
  if (/\.qa\.|\d+\.\d+\.|localhost/.test(host)) {
    return `${location.protocol}//static.qa.91jkys.com/`;
  } else if (/\.pre\./.test(host)) {
    return `${location.protocol}//static.pre.91jkys.com/`;
  } else {
    return `https://static.91jkys.com/`;
  }
};
export const Util = {
  download(url) {
    window.open(url, '_self');
  },
  getUserInfo() {
    let userInfo = this.getCookie('userInfo');
    try {
      userInfo = JSON.parse(userInfo);
    } catch (err) {
      userInfo = {};
      console.warn(err);
    }

    return userInfo;
  },
  getCookie(name) {
    let cookies = document.cookie.split('; ');
    for (let i in cookies) {
      let arr = cookies[i].split('=');
      if (name === arr[0]) return unescape(arr[1]);
    }
    return null;
  },
  setCookie(name, value, expires, path, domain) {
    document.cookie =
      name +
      '=' +
      value +
      (expires ? '; expires=' + getExpires(expires) : '') +
      (path ? '; path=' + path : '') +
      (domain ? '; domain=' + domain : '');
    function getExpires(hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      return date.toGMTString();
    }
  },

  removeCookie(name, path, domain) {
    if (this.getCookie(name)) {
      document.cookie =
        name +
        '=' +
        (path ? ';path=' + path : '') +
        (domain ? ';domain=' + domain : '') +
        ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
  },

  getGwRoot: (() => {
    // let host = window.location.host;
    // if (/\.pre\./.test(host)) {
    //   return `${location.protocol}//apigw.pre.91jkys.com/api`;
    // } else if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
    //   // return `http://dongxc.apigw.qa.91jkys.com/api`; // 调试雪钗

    //   return `${location.protocol}//apigw.qa.91jkys.com/api`;
    //   // return `${
    //   //   location.protocol
    //   // }//yzhstore.apigw.qa.91jkys.com/api`
    // }
    // return `${location.protocol}//apigw.91jkys.com/api`;
    const host = location.host;
    const devHost = getDevHost('');
    if (/\.qa\.|\d+\.\d+\.|localhost/.test(host)) {
      return `${location.protocol}//${devHost}apigw.qa.91jkys.com/api/`;
    } else if (/\.pre\./.test(host)) {
      return `${location.protocol}//${devHost}apigw.pre.91jkys.com/api/`;
    } else {
      return `https://apigw-volc.91jkys.com/api/`;
    }
  })(),
  getApiRoot: (() => {
    let host = window.location.host;
    if (/\.pre\./.test(host)) {
      return `${location.protocol}//drugstore.pre.91jkys.com`;
    } else if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
      return `${location.protocol}//drugstore.qa.91jkys.com`;
    }
    return `https://drugstore.91jkys.com`;
  })(),

  getChatServerAddr() {
    var map = {
      qa: '//chatnew.qa.91jkys.com/',
      pre: '//chatnew.pre.91jkys.com/',
      online: '//chatnew.pre.91jkys.com/'
    };
    return map[this.getEnv()];
  },
  getEnv() {
    let host = window.location.host;
    if (/\.pre\./.test(host)) {
      return 'pre';
    } else if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
      return 'qa';
    } else {
      return 'online';
    }
  },
  // 获取static不同环境域名
  getStaticOrigin() {
    let host = window.location.host;
    if (/\.pre\./.test(host)) {
      return '//static.pre.91jkys.com/';
    } else if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
      return '//static.qa.91jkys.com/';
    } else {
      return 'https://static.91jkys.com/';
    }
  },
  getOrigin: (() => {
    let host = window.location.host;
    if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
      return 'http://static.qa.91jkys.com';
    } else if (host.indexOf('yd.91jkys.com') !== -1) {
      return 'https://static.91jkys.com';
    }
    return location.origin;
  })(),

  parseQuery: parseQuery,

  isNumber(obj) {
    return typeof obj === 'number' && !isNaN(obj);
  },
  submitOnce: (function () {
    var isRunning = false;
    return function (callback, context, time) {
      if (!isRunning) {
        isRunning = true;
        var temp = callback.call(context);
        if (temp && temp.then && temp.then.constructor === Function) {
          temp.then(() => (isRunning = false)).catch(() => (isRunning = false));
        } else {
          setTimeout(function () {
            isRunning = false;
          }, time || 1000);
        }
        return temp;
      }
    };
  })(),

  // 判断字符是否为汉字，
  isChinese(s) {
    return /[\u4e00-\u9fa5]/.test(s);
  },

  // 把字符串中的汉字转换成Unicode
  ch2Unicode(str) {
    if (!str) {
      return;
    }
    var unicode = '';
    for (var i = 0; i < str.length; i++) {
      var temp = str.charAt(i);
      if (this.isChinese(temp)) {
        unicode += '\\u' + temp.charCodeAt(0).toString(16);
      } else {
        unicode += temp;
      }
    }
    return unicode;
  },

  // Unicode编码 转汉字
  unicode2Ch(str) {
    if (str) {
      return unescape(str.replace(/\\/g, '%'));
    }
  },
  toJoinSrt(array, key, code) {
    let strs = array.reduce((str, value) => {
      if (str) {
        return `${str}${code}${value[key]}`;
      } else {
        return `${value[key]}`;
      }
    }, '');
    return strs;
  },
  getItmOrigin() {
    let host = window.location.host;
    if (/\.pre\./.test(host)) {
      return '//itm.pre.91jkys.com/';
    } else if (/(\.qa\.)|localhost:|(127|192|0)\.\d+\.\d+\.\d/.test(host)) {
      return '//itm.qa.91jkys.com/';
    } else {
      return 'https://itm.91jkys.com/';
    }
  }
};

window.Util = Util;

export const hasPermission = (areaPermission, title) => {
  // 负责菜单的显示
  //areaPermission 为菜单需要的权限
  let userRole = store.getters.getRoles;
  return areaPermission.some(role => {
    return userRole.includes(role);
  });
};

export const checkPower = (rolesKey, not) => {
  !Array.isArray(rolesKey) && (rolesKey = rolesKey.split(','));
  const userRole = store.getters.getRoles;
  const ischeck = userRole.some(role => rolesKey.some(role1 => Constant.RoleList[role1] === role));
  return not ? !ischeck : ischeck;
};

// 获取前端的角色key，从而获取前端识别的角色类型
export const getRoleType = roleList => {
  return roleList.reduce((roleType, value) => {
    if (roleType) {
      return `${roleType}_${baseRoleKey[value.code]}`;
    } else {
      return `${baseRoleKey[value.code]}`;
    }
  }, '');
};

// 判断是否具有传入角色或者仅具有传入角色
export const hasRole = (roleType, role, type) => {
  // type为1的时候，判断是否仅具有传入角色
  if (type == 1) {
    return roleType == role;
  } else {
    // 其他，判断是否具有传入角色
    return roleType.indexOf(role) > -1;
  }
};

export const fileDomain = () => {
  return store.getters.fileDomain;
};
export const download = (url, filename, progressCallback, loadCallback) => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  const xhr = new XMLHttpRequest();

  if (progressCallback) {
    xhr.addEventListener('progress', event => progressCallback(event));
  }

  if (loadCallback) {
    xhr.addEventListener('load', event => setTimeout(_ => loadCallback(event), 1000));
  }

  xhr.open('get', url);
  xhr.responseType = 'blob';
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const blob = new Blob([xhr.response]);
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      a.click();
      document.body.removeChild(a);
    }
  };
  xhr.send();
};

export const downloadByIframe = url => {
  VM.$confirm('即将开始下载文件，如果20秒内无响应请点击重试', '提示', {
    confirmButtonText: '重试',
    showCancelButton: false,
    customClass: 'alert',
    center: true
  })
    .then(() => {
      download(url);
    })
    .catch(() => {});
  /*   VM.$alert('即将开始下载文件，如果20秒内无响应请点击重试', '提示', {
    confirmButtonText: '重试',
    center: true,
    callback: action => {
      if (action == 'confirm') {
        download(url);
      }
    }
  }); */
  download(url);
  function download(url) {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    function iframeLoad() {
      console.log('iframe onload');
      const win = iframe.contentWindow;
      const doc = win.document;
      if (win.location.href === url) {
        if (doc.body.childNodes.length > 0) {
          // response is error
        }
        iframe.parentNode.removeChild(iframe);
      }
    }
    if ('onload' in iframe) {
      iframe.onload = iframeLoad;
    } else if (iframe.attachEvent) {
      iframe.attachEvent('onload', iframeLoad);
    } else {
      iframe.onreadystatechange = function onreadystatechange() {
        if (iframe.readyState === 'complete') {
          iframeLoad();
        }
      };
    }
    iframe.src = '';
    document.body.appendChild(iframe);

    setTimeout(function loadUrl() {
      iframe.contentWindow.location.href = url;
    }, 50);
  }
  // window.open(url);
};
export const downloadByLink = (url, filename) => {
  let a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 100);
};
export const transformParamToUrl = param => {
  // get方式拼接参数
  const tempObj = [];
  if (!param || typeof param !== 'object') {
    return;
  }

  for (let i in param) {
    if (param.hasOwnProperty(i) && param[i]) {
      tempObj.push(i);
      tempObj.push('=');
      tempObj.push(param[i]);
      tempObj.push('&');
    }
  }
  // remove the last field &
  tempObj.pop();
  return tempObj.join('');
};

export const isEmpty = val => [undefined, 'null', '""', '[]', '{}'].includes(JSON.stringify(val));

export const delObjectEmpty = origin => {
  return Object.entries(origin).reduce((total, [key, val]) => {
    !isEmpty(val) && (total[key] = val);
    return total;
  }, {});
};

export const judgeMobile = mobile => {
  return mobile && /^1\d{10}$/.test(mobile);
};

export const verifyIdentityNum = str => {
  var regex;
  if (str.length == 15) {
    regex = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[01])\d{3}$/;
  } else if (str.length == 18) {
    regex = /^[1-9]\d{5}(19\d{2}|200[0-9]|20[1-2][0-9])(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[01])\d{3}[0-9Xx]$/;
  } else {
    // Toast('身份证号码必须为15或18位');
    return false;
  }
  if (regex.test(str)) {
    var powers = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arr = str.split('');
    var code = arr.pop().toUpperCase();
    var sum = arr.reduce((pre, val, index) => {
      return pre + val * powers[index];
    }, 0);
    var locations = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    return locations[sum % 11] == code;
  } else {
    // Toast('身份证号码格式错误');
    return false;
  }
};

export const mergeAreaData = (areaData, initData = []) => {
  return Object.keys(areaData).reduce((adapterAreaData, key) => {
    if (area[key]) {
      return adapterAreaData.concat({
        id: key,
        label: areaData[key],
        children: mergeAreaData(area[key])
      });
    } else {
      return adapterAreaData.concat({ id: key, label: areaData[key] });
    }
  }, initData);
};

export const mergeStoreData = (originData, storeData, areaId, initData = []) => {
  return Object.keys(storeData).reduce((adapterStoreData, key) => {
    if (originData[key]) {
      return adapterStoreData.concat({
        id: key,
        label: storeData[key].name,
        children: mergeStoreData(originData, originData[key], areaId)
      });
    } else {
      return adapterStoreData.concat({
        id: key,
        label: storeData[key].name,
        areaId: storeData[key].areaId,
        areaName: storeData[key].areaName,
        disabled: !areaId ? !!storeData[key].areaId : storeData[key].areaId ? storeData[key].areaId != areaId : false
      });
    }
  }, initData);
};

export const dataURLtoFile = (dataUrl, filename) => {
  let arr = dataUrl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bStr = atob(arr[1]);
  let n = bStr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bStr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

let geolocation;
async function getGeolocation() {
  if (geolocation && geolocation.getCurrentPosition) {
    return geolocation;
  }
  await AMapLoader.load();
  await AMapLoader.loadPlugin(['AMap.Geolocation']);
  geolocation = new AMap.Geolocation({
    timeout: 3000 // 设置定位超时时间，默认：无穷大
  });
  return geolocation;
}

export function getLocationByAMap() {
  return new Promise((resolve, reject) => {
    getGeolocation()
      .then(geolocation => {
        geolocation.getCurrentPosition((status, result) => {
          if (status === 'complete') {
            resolve({
              msg: '定位成功',
              ok: true,
              result
            });
          } else {
            $telescopeEvent({
              trackId: TRACK_ACTIONS.ZYWZPC_AMAP_FAIL,
              custom: result
            });
            reject({
              msg: '定位失败，请刷新/重启浏览器重试一下',
              ok: false,
              result
            });
          }
        });
      })
      .catch(err => {
        $telescopeEvent({
          trackId: TRACK_ACTIONS.ZYWZPC_AMAP_FAIL,
          custom: err
        });
        reject({
          msg: '加载定位组件失败，请刷新/重启浏览器重试一下',
          ok: false,
          result: err
        });
      });
  });
}

// 经纬度限制
// 店长兼药师 = 1
// 店长 = 2
// 店员 = 3
// 药师 = 4
// 其他 0
// const RoleMap = {
//   a: 'company_representative', // 公司负责人
//   b: 'remote_trial_pharmacist', // 远程审方药师
//   c: 'regional_head', // 区域负责人
//   d: 'store_manager', // 店长
//   e: 'clerk', // 店员
//   f: 'pharmacist', // 药师
//   g: 'patient', // 患者
//   h: 'province_manager', // 省负责人，监管账号
//   i: 'city_manager', // 市负责人，监管账号
//   j: 'district_manager', // 区负责人，监管账号
//   k: 'third_party_normal_employees' // 第三方普通店员
// };
export function getDistanceRole(roles = []) {
  if (roles.find(x => x === 'store_manager') && roles.find(x => x === 'pharmacist')) {
    return 1;
  }
  if (roles.find(x => x === 'store_manager')) {
    return 2;
  }
  if (roles.find(x => x === 'clerk')) {
    return 3;
  }
  if (roles.find(x => x === 'pharmacist')) {
    return 4;
  }
  return 0;
}

// code 0 通过  1 未设置 2 不在店内

const failDistanceMsg = {
  '1_2': {
    desc: '店长兼药师2， 地理位置不在店内2',
    msg: '系统检测到您当前不在门店内，请前往门店后再进行操作（如果您已在门店内，立即修改正确的门店坐标）',
    confirmText: '去设置',
    cancelText: '取消',
    push: '/shopManagement'
  },
  '2_2': {
    desc: '店长2， 地理位置不在店内2',
    msg: '系统检测到您当前不在门店内，请前往门店后再进行操作（如果您已在门店内，立即修改正确的门店坐标）',
    confirmText: '去设置',
    cancelText: '取消',
    push: '/shopManagement'
  },
  '3_2': {
    desc: '店员3， 地理位置不在店内2',
    msg: '您当前不在本店范围内，请前往店铺再进行操作（如果您已在门店内，请联系店长进入PC端→门店管理→操作→查看，检查门店地图坐标是否准确）'
  },
  '4_1': {
    desc: '药师4， 未设置地理位置1',
    msg: '该门店未在PC端设置准确的门店定位（请联系店长进入PC端→门店管理→操作→查看，检查门店地图坐标是否准确）'
  },
  '4_2': {
    desc: '药师4， 地理位置不在店内2',
    msg: '您当前不在本店范围内，请前往店铺再进行操作（如果您已在门店内，请联系店长进入PC端→门店管理→操作→查看，检查门店地图坐标是否准确）'
  }
};

export function getFailDistanceMsg(roles, code) {
  const disRole = getDistanceRole(roles);
  console.log('disRole = ', disRole);
  const obj = failDistanceMsg[`${disRole}_${code}`];
  return obj ? { ...obj } : undefined;
}

export function toThousands(value) {
  let num = (value || 0).toString();
  let result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return result;
}

export function toChinesNum(num) {
  let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; // changeNum[0] = "零"
  let unit = ['', '十', '百', '千', '万'];
  num = parseInt(num);
  let getWan = temp => {
    let strArr = temp.toString().split('').reverse();
    let newNum = '';
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ''
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
          ? ''
          : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) + newNum;
    }
    return newNum;
  };
  let overWan = Math.floor(num / 10000);
  let noWan = num % 10000;
  if (noWan.toString().length < 4) noWan = '0' + noWan;
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
}

export const constOptions = (value, options) => {
  const res = options.filter(item => item.value === value);
  const [option = {}] = res;
  return option.label || '--';
};

export const optUserNameShowContent = (optUserName, accountNo) => {
  return `${optUserName || '公司负责人'} (账号：${accountNo}) `;
};

export function mapRequestParamsEmpty2Null(params) {
  if (!(params instanceof Array) && params !== null && typeof params === 'object') {
    return Object.entries(params).reduce((ret, [key, value]) => {
      return { ...ret, [key]: value === '' ? null : value };
    }, {});
  }
  return params;
}

export function type2Datetime(type) {
  switch (type) {
    case 'today': {
      return {
        startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'yesterday': {
      const yesterday = dayjs().subtract(1, 'days');
      return {
        startTime: yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    }
    case 'week':
      return {
        startTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'month':
      return {
        startTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      };
    case 'year':
      return {
        startTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      };
  }
}

export const shortcuts = [
  {
    text: '昨日',
    onClick(picker) {
      const yesterday = dayjs().subtract(1, 'days');
      picker.$emit('pick', [
        yesterday.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        yesterday.endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ]);
    }
  },
  {
    text: '本周',
    onClick(picker) {
      picker.$emit('pick', [
        dayjs().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss')
      ]);
    }
  },
  {
    text: '本月',
    onClick(picker) {
      picker.$emit('pick', [
        dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')
      ]);
    }
  },
  {
    text: '本年',
    onClick(picker) {
      picker.$emit('pick', [
        dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
      ]);
    }
  }
];

export function getFileSuffix(src) {
  const reg = /^.+\.([^\\?]+)(\?.+)?$/;
  return reg.exec(src)?.[1];
}

export function transformPrescriptionImageByCss(src, callback) {
  const image = new Image();

  image.src = src;

  image.onload = () => {
    const { naturalWidth, naturalHeight } = image;

    if (naturalWidth > naturalHeight) {
      const rdx = 260 / ((naturalHeight / naturalWidth) * 260);

      const height = 260 / (naturalWidth / naturalHeight);

      const currentHeight = 260 / (naturalHeight / naturalWidth);

      // eslint-disable-next-line standard/no-callback-literal
      callback({
        transform: `translate(0,${(currentHeight - height) / 2 + 37}px) rotate(-90deg) scale(${rdx}) `
      });
    } else {
      callback();
    }
  };
}

export function toDataUrl(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.src = src;

    image.crossOrigin = 'Anonymous';

    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };

    image.onerror = () => {
      reject(false);
    };
  });
}

export const runWhenIdle = cb => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(cb, { timeout: 2000 });
  } else {
    setTimeout(cb, 0);
  }
};
